export const enum ToggleSubscriptionState {
  Enable = 'enable',
  Disable = 'disable',
}
